export enum ShiftType {
	AM = 'am',
	PM = 'pm',
	NIGHT = 'night',
	ALL = 'all',
}

export enum SortOrderings {
	BY_GROUP = 'report_group_id',
	BY_LAST_MILK_AMOUNT = 'report_milk_yield',
	BY_LAST_MILKING_DT = 'report_ident_dt',
	BY_PERIOD = 'period',
	BY_MILKING_HALL = 'milking_hall',
}
